<script>
export default {
  name: "AddressRegisterForm",
  data() {
    return {
      address: "",
      valid: false,
      rules: [
        (v) => !!v || "入力が必要な項目です。",
        (v) => /.+@.+/.test(v) || "有効なメールアドレスを入力してください。",
      ],
    };
  },
  methods: {
    clickBtn() {
      if (this.valid) {
        this.$emit("submit", this.address);
        this.address = "";
      }
    },
  },
};
</script>

<template>
  <v-form v-model="valid">
    <v-text-field
      append-outer-icon="mdi-plus-box-outline"
      v-model="address"
      @click:append-outer="clickBtn"
      :rules="rules"
      required
    ></v-text-field>
  </v-form>
</template>
